import React, { useState, useContext, useEffect, useRef, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/main.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, useLocation, useNavigate, Link, Navigate } from "react-router-dom";
import Header from "./sharedComponent/Header";
import Footer from "./sharedComponent/Footer";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import Notification from "./sharedComponent/Notification";
import { notifyError, notifySuccess } from "./sharedComponent/notify";
import { toast } from "react-toastify";
import { Button, Form, Modal } from "react-bootstrap";
import { deleteWithAuthCall, postWithAuthCall, postWithAuthCallWithErrorResponse, putMultipartWithAuthCall, putMultipartWithAuthCallWithErrorResponse, simpleGetCallWithErrorResponse } from "./api/ApiServices";
import ApiConfig from "./api/ApiConfig";
import SocketService from "./utils/SocketService";
import { AppContext } from "./context/AppContext";
import ringtoneWeb from "../src/assets/images/phone.mp3";
import ConfirmModal from "./sharedComponent/ConfirmModal";
import ProtectedRoute from "./ProtectedRoutes";

const Login = React.lazy(() => import("./pages/Auth/Login"));
const Registration = React.lazy(() => import("./pages/Auth/Registration"));
const ForgotPassword = React.lazy(() => import("./pages/Auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("./pages/Auth/ResetPassword"));
const PetInformation = React.lazy(() => import("./pages/Auth/PetInformation"));
const GetStarted = React.lazy(() => import("./pages/Auth/GetStarted"));
const Home = React.lazy(() => import("./pages/Home/Home"));
const DoctorsList = React.lazy(() => import("./pages/Doctors/DoctorsList"));
const ProfileSetting = React.lazy(() => import("./pages/CustomerProfile/ProfileSetting"));
const DoctorDetails = React.lazy(() => import("./pages/Doctors/DoctorDetails"));
const BookAppoitment = React.lazy(() => import("./pages/Doctors/BookAppoitment"));
const MyOrders = React.lazy(() => import("./pages/CustomerProfile/MyOrders"));
const MyOrderDetails = React.lazy(() => import("./pages/CustomerProfile/MyOrderDetails"));
const PetShops = React.lazy(() => import('./pages/PetShops/PetShops'));
const PetShopDetails = React.lazy(() => import('./pages/PetShops/PetShopDetails'));
const PetAllSellers = React.lazy(() => import('./pages/PetShops/PetAllSellers'));
const PetCart = React.lazy(() => import('./pages/PetShops/PetCart'));
const PetCheckout = React.lazy(() => import('./pages/PetShops/PetCheckout'));
const CategoryList = React.lazy(() => import('./pages/PetShops/CategoryList'));
const MenuPage = React.lazy(() => import('./pages/Menu/MenuPage'));

function App() {
  const location = useLocation();
  let currentRoute = location.pathname;
const [showPopup, setShowPopup] = useState(false);
const [show, setShow] = useState(false);
  const { setUserID, set_selected_location,socket,UserID,loginType } = useContext(AppContext);
  const [registeredData, setRegisteredData] = useState([]);
  const [registeredDataOriginal, setRegisteredDataOriginal] = useState([]);
  const [FastOriginal, setFastOriginal] = useState([]);
  const [modal, setModal] = useState(false);
const ringtone = new Audio(ringtoneWeb);
// ringtone.loop = true;
  const [refresh, setRefresh] = useState(false);
const [callTimer, setCallTimer] = useState(30);
const intervalRef = useRef(null);

// optional: store ringtone as a ref if needed
const ringtoneRef = useRef(null);
// e.g. useEffect(() => { ringtoneRef.current = new Audio('/ring.mp3'); }, []);

useEffect(() => {
  // cleanup on unmount: clear any running interval
  return () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
}, []);
const showCustomNotification = () => {
  let timer = 30;
  setCallTimer(timer);

  const interval = setInterval(() => {
    timer -= 1;
    setCallTimer(timer);

    if (timer <= 0) {
      ringtone.pause();
      ringtone.currentTime = 0;
      toast.dismiss();
      clearInterval(interval);
    }
  }, 1000);

  toast(
    <div >
      <div style={toastStyles.header}>
        📞 <span>Incoming Call</span>
      </div>

      <div style={toastStyles.subText}>customer calling you...</div>

      {/* Countdown Timer */}
      {/* <div style={toastStyles.timerBox}>
        Auto closing in <strong>{callTimer}s</strong>
      </div> */}

      <div style={toastStyles.btnRow}>
        {/* ACCEPT */}
        <button
          style={toastStyles.acceptBtn}
          onClick={() => {
            ringtone.pause();
            ringtone.currentTime = 0;
            clearInterval(interval);
            setShowPopup(true);
            toast.dismiss();
          }}
        >
          Accept
        </button>

        {/* DECLINE */}
        <button
          style={toastStyles.declineBtn}
          onClick={() => {
            ringtone.pause();
            ringtone.currentTime = 0;
            clearInterval(interval);
            toast.dismiss();
          }}
        >
          Decline
        </button>
      </div>
    </div>,
    { autoClose: false }
  );
};






const [firstName, setFirstName] = useState("");
const [search, setsearch] = useState("");
const [lastName, setLastName] = useState("");
const [phone, setPhone] = useState("");
const [email, setEmail] = useState("");
// const [UserID, setUserID] = useState("");
  const [addressList, setAddressList] = useState([{
    first_name: "",
    gender: "",
    location: "",
    phone_number: "",
  }]);


const [formData, setFormData] = useState({
  id: null, // local id for UI; update payload uses user_address_id for update
  user_address: "",
  user_pincode: "",
  user_street: "",
  user_landmark: "",
  user_address_type: "work", // use 'work' | 'home' | 'other' as in API
  user_latitude: "",     // required by API
  user_longitude: "",    // required by API
  user_address_mobile: "",   // phone
  user_address_user_name: "",// name
  user_house_address: "",    // house address field
  delivery_intructions: "",  // delivery instructions
  user_address_is_default: 0 // 0 or 1
});


const provider = new OpenStreetMapProvider();



  const handleClose = async () => {
setShow(false)
  };

  useEffect(() => {
    loadAddressList();
  }, [refresh]);


    useEffect(() => {
   
  }, [UserID]);

  const loadAddressList = async () => {
    const res = await simpleGetCallWithErrorResponse(ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS);
    if (res?.json.success){
setAddressList(res.json?.data);
// let filter = res?.json.data?.filter((i) => i?.user_address_is_default == 1);
//       if (filter?.length > 0) {
//         // dispatch(setLocation({ selected_location: filter?.[0] }));
//         localStorage.setItem.setItem(
//           'SELECTED_LOCATION',
//           JSON.stringify(filter?.[0])
//         );
//         // navigation.navigate("DrawerScreen");
//       }
    } 
                
    else {
      const token = JSON.parse(localStorage.getItem('Token'))
      if(token){
notifyError("Failed to fetch addresses")
      }
    } 
  };





  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  // 🔍 Search Address Function
  const searchPlace = async (input) => {
    if (!input || input.length < 3) {
      setResults([]);
      return;
    }
    try {
      const searchResults = await provider.search({ query: input });
      setResults(searchResults);
    } catch (error) {
      console.error("Address search failed:", error);
    }
  };

  // Auto search on input change
  const handleSearchChange = (value) => {
    setQuery(value);
    searchPlace(value);
  };

  // Select search result
  const handleSelect = (item) => {
    setQuery(item?.label || item?.display_name);
    handleInputChange({
      target: { name: "user_address", value: item?.label || item?.display_name },
    });
    setResults([]);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = async () => {
  if (UserID) {
    // UPDATE user
    await updateUserDetails();
  } else {
    // CREATE user
    await CreateUser();
  }
};


useEffect(() => {
  if((loginType === 'Agent' || loginType === 'agent')){




  if (!socket) return;

  const handleLiveCall = (data) => {
 
    showCustomNotification();

    // Set all incoming data into state
    setFirstName(data.first_name || "");
    setLastName(data.last_name || "");
    setPhone(data.number || "");
    setEmail(data.email || "");
    setUserID(data.user_id)


  };

  socket.on("live_call", handleLiveCall);

  return () => {
  
    socket.off("live_call", handleLiveCall);
  };

    }
}, [socket,loginType]);


const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));



 



const updateUserDetails = async () => {
  if (!UserID) {
    console.log("No UserID → calling CreateUser()");
    return await CreateUser();
  }

  const url = `${ApiConfig.UPDATE_CONTACT_USER_WIF}${UserID}`;
  console.log("UPDATE URL =", url);

  const requestBody = {
    firstName,
    lastName,
    email,
    phoneNumber: phone,
  };

  try {
    const res = await putMultipartWithAuthCallWithErrorResponse(
      url,
      JSON.stringify(requestBody)   // correct
    );

    if (res?.json?.success) {
      notifySuccess(res?.json?.message);
      setModal(true) 
      setShowPopup(false)
    }
  } catch (e) {
    console.error("UPDATE API Error:", e);
  }
};





const CreateUser = async () => {
  const requestBody = {
    full_name: `${firstName} ${lastName}`,
    email: email || "",
    phone_number: phone,
    Hash: "forios",
    type: "Inquiry",
    source: "Call",
  };

  try {
    const res = await postWithAuthCall(
      ApiConfig.CREATE_USER,
      JSON.stringify(requestBody)
    );

    console.log("Create user response:", res);

    if (res?.success) {
      setUserID(res?.user?.id);
      notifySuccess("User created successfully");
        setModal(true)
        setShowPopup(false)
    }
  } catch (err) {
    console.log("CreateUser error:", err);
  }
};


    useEffect(() => {
   getRegisteredUser()
  }, [UserID]);



const getRegisteredUser = async () => {
  try {


    const url = `${ApiConfig.GET_REGISTERED_USER_AGENT}?type=All&page_size=9999`;
    console.log("URL =", url);

    const response = await simpleGetCallWithErrorResponse(url);
    console.log("response ====>", response);

    if (response?.json.success) {

      setRegisteredDataOriginal(response?.json.data);
      setFastOriginal(response?.json.data[0])

      // if (MainItem?.notification_type === "Call") {

        // let filtered = response?.data?.filter(
        //   (i) => String(i?.phone_number) === String(MainItem?.user_mobile)
        // );

      //   if (filtered?.length > 0) {
      //     setRegisteredData(filtered);
      //   } else {
      //     setRegisteredData(response?.data);
      //   }

      //   return; // STOP HERE
      // }

      // DEFAULT
      setRegisteredData(response?.data);
    }

  } catch (err) {
    console.log("API Error ===>", err);
  } finally {
  
  }
};












const filteredContacts = registeredDataOriginal?.filter((item) => {
  const s = search.toLowerCase();

  return (
    (item.first_name || "").toLowerCase().includes(s) ||
    (item.phone_number || "").includes(search) ||
    (item.email || "").toLowerCase().includes(s)
  );
});


const handleSubmitAdd = async () => {
  // if (!formData.user_address.trim()) return alert("Please enter address.");

  // common fields for create/update
  // Note: API wants different key for update (user_address_id)
  if (formData.id) {
    // Update payload (example you provided)
    const updatePayload = {
      user_address_id: formData.id, // <-- IMPORTANT for update
      user_address: formData.user_address,
      user_latitude: formData.user_latitude || "",
      user_longitude: formData.user_longitude || "",
      user_address_type: formData.user_address_type || "work",
      user_address_mobile: formData.user_address_mobile || "",
      user_address_user_name: formData.user_address_user_name || "",
      user_house_address: formData.user_house_address || "",
      delivery_intructions: formData.delivery_intructions || "",
      user_address_is_default: formData.user_address_is_default ? 1 : 0,
    };

    try {
      const res = await putMultipartWithAuthCallWithErrorResponse(
        `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${formData.id}`,
        JSON.stringify(updatePayload)
      );
      if (res?.json.success) {
      
                notifySuccess("Address updated successfully!")
                setQuery("");
                setFormData({
  id: null, // local id for UI; update payload uses user_address_id for update
  user_address: "",
  user_pincode: "",
  user_street: "",
  user_landmark: "",
  user_address_type: "work", // use 'work' | 'home' | 'other' as in API
  user_latitude: "",     // required by API
  user_longitude: "",    // required by API
  user_address_mobile: "",   // phone
  user_address_user_name: "",// name
  user_house_address: "",    // house address field
  delivery_intructions: "",  // delivery instructions
  user_address_is_default: 0 // 0 or 1
})

      setResults([]);

        setFormData({
          id: null,
          user_address: "",
          user_pincode: "",
          user_street: "",
          user_landmark: "",
          user_address_type: "work",
          user_latitude: "",
          user_longitude: "",
          user_address_mobile: "",
          user_address_user_name: "",
          user_house_address: "",
          delivery_intructions: "",
          user_address_is_default: 0,
        });
        
        loadAddressList();
      } else {
        alert(res?.message || "Failed to update address");
      }
    } catch (e) {
      console.error(e);
      alert("Failed to update address");
    }
  } else {
    // Create payload (example you provided)
    const createPayload = {
      user_address: formData.user_address,
      user_latitude: formData.user_latitude || "",
      user_longitude: formData.user_longitude || "",
      user_address_type: formData.user_address_type || "work",
      user_address_mobile: formData.user_address_mobile || "",
      user_address_user_name: formData.user_address_user_name || "",
      user_house_address: formData.user_house_address || "",
      delivery_intructions: formData.delivery_intructions || "",
      user_address_is_default: formData.user_address_is_default ? "" : "", 
        // your example had "" for create; adjust if backend expects 0/1 or empty
    };

    try {
      // your code used postWithAuthCall(JSON.stringify(payload))
      const res = await postWithAuthCallWithErrorResponse(
        ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS,
        JSON.stringify(createPayload)
      );
      if (res?.json.success) {
        
                notifySuccess("Address added successfully!")
      setResults([]);
        
        setFormData({
          id: null,
          user_address: "",
          user_pincode: "",
          user_street: "",
          user_landmark: "",
          user_address_type: "work",
          user_latitude: "",
          user_longitude: "",
          user_address_mobile: "",
          user_address_user_name: "",
          user_house_address: "",
          delivery_intructions: "",
          user_address_is_default: 0,
        });
        loadAddressList();
      } else {
        alert(res?.message || "Failed to add address");
      }
    } catch (e) {
      console.error(e);
      alert("Failed to add address");
    }
  }
};


const handleEdit = (item) => {
  
  setQuery(item.user_address ?? "")
  setFormData({
    id: item.id ?? null,
    user_address: item.user_address ?? "",
    user_pincode: item.user_pincode ?? "",
    user_street: item.user_street ?? "",
    user_landmark: item.user_landmark ?? "",
    user_address_type: item.user_address_type ?? "work",
    user_latitude: item.user_latitude ?? "",
    user_longitude: item.user_longitude ?? "",
    user_address_mobile: item.user_address_mobile ?? "",
    user_address_user_name: item.user_address_user_name ?? "",
    user_house_address: item.user_house_address ?? "",
    delivery_intructions: item.delivery_intructions ?? "",
    // API expects 1/0 for default
    user_address_is_default: item.user_address_is_default ? 1 : 0,
  });
  window.scrollTo({ top: 0, behavior: "smooth" });
};


  const handleUpdateDefault = async (selectedLocation) => {
    const updatedList = addressList.map((i) => ({
      ...i,
      user_address_is_default: i.id === selectedLocation.id ? 1 : 0,
    }));
    setAddressList(updatedList);
    setRefresh(!refresh);
    localStorage.setItem('user_selected_location',  JSON.stringify(selectedLocation))
set_selected_location(selectedLocation)
    try {
      const res = await putMultipartWithAuthCallWithErrorResponse(
        `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${selectedLocation.id}`,
        JSON.stringify({ ...selectedLocation, user_address_is_default: 1 })
      );
   
      if (res.json?.success) {
    //  setAddressList(res?.data)
                notifySuccess("Location Set successfully")

        loadAddressList();
      }
    } catch (e) {
      console.error(e);
      loadAddressList();
    }
  };





   const [showConfirm, setShowConfirm] = useState(false);

     const [selectedItem, setSelectedItem] = useState(null);
   const [deleteAddressLoading, setDeleteAddressLoading] = useState(false);

     const handleCancel = () => {
    setShowConfirm(false);
    setSelectedItem(null);
  };
   const handleShowConfirm = (item) => {
    setSelectedItem(item);
    setShowConfirm(true);
  };

  const deleteAddress = async () => {
    
    if (!selectedItem) return;
    setDeleteAddressLoading(true);
      const res = await deleteWithAuthCall(
        `${ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS}/${selectedItem.id}`
      );
      if (res?.success) {

                notifySuccess("Address deleted successfully")
                setDeleteAddressLoading(false);
                handleCancel ();
        
        loadAddressList();
      } else  {
        
        notifyError(res?.message || "Error deleting address");
        setDeleteAddressLoading(false);
      }
  };


  return (
    <>
 <>
{showPopup && (
  <div style={styles.overlay}>
    <div style={styles.popup}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>{UserID ? "Update Contact":"Add Contact"}</h2>

      {/* FIRST NAME */}
      <div style={{ marginBottom: "12px" }}>
        <label style={styles.label}>First Name</label>
        <input
          style={styles.input}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>

      {/* LAST NAME */}
   

      {/* EMAIL */}
      <div style={{ marginBottom: "12px" }}>
        <label style={styles.label}>Email</label>
        <input
          type="text"
          style={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      {/* PHONE */}
      <div style={{ marginBottom: "12px" }}>
        <label style={styles.label}>Phone</label>
        <input
          type="text"
          style={styles.input}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      {/* BUTTONS */}
      <div style={styles.row}>
  
  {/* Cancel Button */}
  <button style={styles.btn} onClick={() => setShowPopup(false)}>
    Cancel
  </button>

  {/* Done Button */}
  <Link to="#" className="loginBtn">
    <button
      type="button"
      className="btn-custom"
      style={styles.doneBtn}
      onClick={() => handleSubmit()}
    >
     {UserID ? "Update":"Add"}
    </button>
  </Link>

</div>

    </div>
  </div>
)}

<ConfirmModal
        show={showConfirm}
        title="Confirm Delete"
        message="Are you sure you want to delete this address?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={deleteAddress}
        onCancel={handleCancel}
        loading={deleteAddressLoading}
      />
{modal && (
  <div style={styles.overlay}>
    <div style={styles.modal}>

      {/* ---- HEADER ---- */}
      <div style={styles.header}>
        <button onClick={() => setModal(false)} style={styles.backBtn}>←</button>
        <h2 style={styles.title}>Search Contact</h2>
      </div>

      {/* ---- SEARCH BAR ---- */}
      <div style={styles.searchBox}>
        <input
          style={styles.searchInput}
          placeholder="Search Contacts & Call logs"
          value={search}
          onChange={(e) => setsearch(e.target.value)}
        />
        <span style={styles.searchIcon}>🔍</span>
      </div>

      {/* ---- SCROLLABLE AREA ---- */}
      <div style={styles.scrollArea}>

        {/* ---- MAIN CONTACT ---- */}
        {FastOriginal && (
          <div
            style={styles.card}
            onClick={() => {
              loadAddressList()
              setModal(false);
              setShowPopup(false);
              setShow(true)
            }}
          >
            <p><strong>Name</strong><br />{FastOriginal.first_name}</p>
            <p><strong>Email</strong><br />{FastOriginal.email}</p>
            <p><strong>Phone</strong><br />{FastOriginal.phone_number}</p>
            <p><strong>Category</strong><br />{FastOriginal.categories || "—"}</p>
            <p><strong>Source</strong><br />{FastOriginal.source}</p>
            <p><strong>Date</strong><br />{FastOriginal.created_at}</p>
            <p><strong>Type</strong><br />{FastOriginal.type}</p>
          </div>
        )}

        {/* ---- FILTER LOGIC ---- */}
        {filteredContacts?.length === 0 && (
          <p style={{ textAlign: "center", marginTop: "20px" }}>No results found</p>
        )}

        {/* ---- FILTERED CONTACT LIST ---- */}
        {filteredContacts?.map((item, index) => (
          <div
            key={index}
            style={styles.card}
            onClick={() => {
              setFastOriginal(item);
              setShowPopup(false);
            }}
          >
            <p><strong>Name</strong><br />{item.first_name}</p>
            <p><strong>Phone</strong><br />{item.phone_number}</p>
          </div>
        ))}

      </div>
    </div>
  </div>
)}



 <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{formData.id ? "Edit Address" : "Add New Address"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="wrapper-cards">

          {/* ────────────── ADD/EDIT ADDRESS ─────────────── */}
          <section className="wrapper-cards mt-3 p-3 border rounded bg-white shadow-sm">

            <div className="row">

              {/* Address Search Field */}
              <div className="col-md-12 form-group">
                <Form.Group>
                  <Form.Label>Address (Area, Flat No., Street, ...)</Form.Label>

                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search address..."
                      value={query}
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />

                    {results.length > 0 && (
                      <ul
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          listStyle: "none",
                          margin: 0,
                          padding: "5px 0",
                          maxHeight: "200px",
                          overflowY: "auto",
                          zIndex: 9999,
                        }}
                      >
                        {results.map((r, index) => (
                          <li
                            key={index}
                            onClick={() => handleSelect(r)}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {r.label || r.display_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Form.Group>
              </div>

              {/* Phone Number */}
              <div className="col-md-6 form-group mt-3">
                <Form.Group>
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="user_address_mobile"
                    placeholder="Phone Number"
                    value={formData.user_address_mobile}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </div>

              {/* Address Type */}
                 <div className="col-md-6 form-group mt-3">
  <Form.Label>Address Type</Form.Label>

  <div style={{ display: "flex", gap: "12px" }}>
    {["Home", "Work", "Other"].map((type) => {
      const isActive = formData.user_address_type === type;

      return (
        <button
          key={type}
          type="button"
          onClick={() =>
            setFormData({
              ...formData,
              user_address_type: type,
            })
          }
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 18px",
            borderRadius: "8px",
            border: isActive ? "2px solid #f9bc03" : "1px solid #ddd",
            backgroundColor: isActive ? "#f8f8f8" : "#fff",
            cursor: "pointer",
            fontWeight: "500",
            transition: "all 0.2s ease",
            
          }}
        >
          {type === "Home" && <i className="bi bi-house"></i>}
          {type === "Work" && <i className="bi bi-briefcase"></i>}
          {type === "Other" && <i className="bi bi-geo-alt"></i>}
          <span>{type}</span>
        </button>
      );
    })}
  </div>
</div>
            </div>

            {/* Save / Update Button */}
            <div className="mt-4 text-end">
              <Button
                onClick={handleSubmitAdd}
                style={{
                  border: "none",
                  backgroundColor: "#f9bc03",
                  color: "#fff",
                  width: "260px",
                  height: "42px",
                  borderRadius: "20px",
                }}
              >
                {formData.id ? "Update Address" : "Save Address"}
              </Button>
            </div>
          </section>

          {/* ───────────────── SAVED ADDRESSES ─────────────── */}
          <section className="wrapper-cards mt-4 p-3 border rounded bg-white shadow-sm">
            <h5>Saved Address</h5>

            <div className="row mt-3">
              {addressList.map((item) => (
                <div
                  key={item.id}
                  className="col-md-6 mb-3"
                  onClick={() => handleUpdateDefault(item)}
                >
                <div
                className={`p-3 rounded border ${
                  item.user_address_is_default === 1
                    ? "bg-light-card-map"
                    : "border-secondary"
                }`}
              >
                    <div className="d-flex justify-content-between">
                      <div>
                        <strong>
                          {item.user_address_type?.replace(/\s*\(.*?\)\s*/g, "")}
                        </strong>
                        <p className="mb-1">{item.user_address}</p>
                      </div>

                      {/* Edit + Delete Buttons */}
                      <div className="d-flex align-items-start">
                        <Button
                          size="sm"
                          style={{
                            border: "none",
                            backgroundColor: "#f9bc03",
                            color: "#fff",
                            borderRadius: "20px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(item);
                          }}
                        >
                          ✎
                        </Button>

                        {item.user_address_is_default !== 1 && (
                          <Button
                            size="sm"
                            className="ms-2"
                            style={{
                              border: "none",
                              backgroundColor: "#c91a1a",
                              color: "#fff",
                              borderRadius: "20px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowConfirm(item);
                            }}
                          >
                            🗑
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
             
                </div>
              ))}
            </div>
                   <div style={styles.row}>
        <button style={styles.btn} onClick={() => setShow(false)}>
          Cancel
        </button>
        <button className="btn-custom"   style={styles.doneBtn}  onClick={() => {
          setShow(false)
setShowPopup(false) 
setModal(false)
        }}>Done</button>
      </div>
          </section>
        </div>
      </Modal.Body>
    </Modal>
    </>
    
      <div className="screens-wrapper container gx-0">
             {/* <button onClick={showCustomNotification}>Show Notification + Popup</button> */}

          <ToastContainer/>
          
        {currentRoute === "/Login" ||
          currentRoute === "/ForgotPassword" ||
          currentRoute === "/Registration" ||
          currentRoute === "/ResetPassword" ||
          currentRoute === "/PetInformation" ||
          currentRoute === "/GetStarted" ? (
          <>

          </>
        ) : (
          <> <Header /></>
        )}
        <Suspense fallback={<div className="page-loader"><span className="page-loader__spinner" /></div>}>
        <Routes>
          {/*=============== Auth Pages ========== */}
          {/* <Route path="/" element={<Login />} />
          <Route path="Registration" element={<Registration />} />
          <Route path="ForgotPassword" element={<ForgotPassword />} />
          <Route path="ResetPassword" element={<ResetPassword />} />
          <Route path="PetInformation" element={<PetInformation />} />
          <Route path="GetStarted" element={<GetStarted />} /> */}
          {/* ========== Home Screens ====== */}

          <Route path="/Login" element={localStorage.getItem('Token') ? <Navigate to='/' /> : <Login />}/>
        <Route path="Registration" element={<Registration />} />

{/* Following are protected routes */}

<Route element= { < ProtectedRoute/ > }>


      {/* This wrapper protects all nested routes */}
           <Route path="Home" element={<Home />} />
          {/* ========== Doctor's Screens ====== */}
             <Route path="/" element = {<Navigate to='/Home' />} />
             <Route path="Home" element={<Home />} />
          <Route path="DoctorsList" element={<DoctorsList />} />
          <Route path="DoctorDetails" element={<DoctorDetails />} />
          <Route path="BookAppoitment" element={<BookAppoitment />} />
          {/* ========== Medicines Screens ====== */}
          
          {/* ========== Vet/Pet Shop Screens ====== */}
             <Route path="ListShops" element={<PetShops />} />
             <Route path="category-list" element={<CategoryList />} />
             <Route path="menu" element={<MenuPage />} />

          <Route path="PetShopDetails" element={<PetShopDetails />} />
          <Route path="PetAllSellers" element={<PetAllSellers />} />
          <Route path="Cart" element={<PetCart />} />
          <Route path="Checkout" element={<PetCheckout />} />
          
          {/* ========== Profile Setting ====== */}
          <Route path="ProfileSetting" element={<ProfileSetting />} />
          <Route path="MyOrders" element={<MyOrders />} />
          <Route path="MyOrderDetails/:id" element={<MyOrderDetails />} />
          <Route path="Notification" element={<Notification />} />
     
     {/*  Catch-all for undefined routes (user IS logged in) */}
        <Route path="*" element={<Navigate to="/Home" replace />} />
   

           {/*  Catch-all for undefined routes (user NOT logged in) */}
      <Route path="*" element={<Navigate to="/Login" replace />} />
        
</Route>


        </Routes>
        </Suspense>
      </div>
      {currentRoute === "/Login" ||
        currentRoute === "/ForgotPassword" ||
        currentRoute === "/Registration" ||
        currentRoute === "/ResetPassword" ||
        currentRoute === "/PetInformation" ||
        currentRoute === "/GetStarted" ? null : (
        <Footer />
      )}
    </>
  );
}

export default App;
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "25px",
    width: "650px",
    height: "450px",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
  },
  label: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#444",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    outline: "none",
    fontSize: "14px",
    marginTop: "4px",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
    alignItems: "center",
  },

  btn: {
    padding: "10px 20px",
    borderRadius: "8px",
    background: "#000000ff",
    border: "1px solid #999",
    cursor: "pointer",
    fontSize: "14px",
     width: "260px",
    height: "42px",
    color: "#fff",

  },
scrollArea: {
  height: "calc(70vh - 160px)",
  overflowY: "auto",
  marginTop: "10px",
  paddingRight: "8px",
},
  doneBtn: {
    border: "none",
    backgroundColor: "rgb(249, 188, 3)",
    color: "#fff",
    width: "260px",
    height: "42px",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },

    modal: {
    width: "65%",
    height: "70%",
    overflowY: "auto",
    background: "#ebebebff",
    borderRadius: "20px",
    padding: "15px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  backBtn: {
    background: "transparent",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
  },

  title: {
    fontSize: "22px",
    margin: 0,
  },

  searchBox: {
    marginTop: "15px",
    position: "relative",
  },

  searchInput: {
    width: "100%",
    padding: "12px 40px 12px 15px",
    borderRadius: "30px",
    border: "1px solid #ddd",
    fontSize: "16px",
  },

  searchIcon: {
    position: "absolute",
    right: "15px",
    top: "10px",
    fontSize: "22px",
    color: "#ff5733",
  },

   card: {
    background: "#ffffffff",
    padding: "20px",
    marginTop: "20px",
    borderRadius: "20px",
    borderBottom: "4px solid #000000ff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#000000ff"
  },
};


const toastStyles = {
  container: {
    padding: "16px 18px",
    width: "260px",
    borderRadius: "14px",
    background: "#ffffff",
    boxShadow: "0px 4px 14px rgba(0,0,0,0.15)",
    fontFamily: "Inter, sans-serif",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "18px",
    fontWeight: 600,
    color: "#222",
  },

  subText: {
    marginTop: "6px",
    fontSize: "14px",
    color: "#666",
  },

  timerBox: {
    marginTop: "10px",
    padding: "8px",
    background: "#f2f2f2",
    borderRadius: "10px",
    fontSize: "14px",
    textAlign: "center",
    color: "#444",
    fontWeight: 500,
  },

  btnRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "14px",
  },

  acceptBtn: {
    flex: 1,
    padding: "8px",
    background: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    marginRight: "8px",
  },

  declineBtn: {
    flex: 1,
    padding: "8px",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
};
